import { gql } from "@apollo/client";

const DELETE_CONTACT_DOCUMENT = gql`
  mutation DeleteContactDocument($input: DeleteContactDocumentInput!) {
    deleteContactDocument(input: $input) {
      success
      error
      response
    }
  }
`;

const GET_CONTACT_DOCUMENT_UPLOAD_URLS = gql`
  query GetContactDocumentUploadUrls($contactId: Int!, $filenames: [String]!) {
    getContactDocumentUploadUrls(contactId: $contactId, filenames: $filenames) {
      success
      error
      urls {
        url
        key
        filename
      }
    }
  }
`;

export { DELETE_CONTACT_DOCUMENT, GET_CONTACT_DOCUMENT_UPLOAD_URLS };
